import * as React from "react";
import { Route, Switch } from "react-router-dom";
import { Observable } from "rxjs";

import { routes } from "config/urls";
import { NotFound } from "pages/NotFound/NotFound";
import PullHistory from "pages/PullHistory";
import PushHistory from "pages/PushHistory";

const AppRouter: React.FC<{
  queueSync$?: Observable<void>;
}> = ({ queueSync$ }) => (
  <Switch>
    <Route
      path={routes.companies.pullHistory}
      component={() => <PullHistory queueSync$={queueSync$} />}
    />
    <Route path={routes.companies.pushHistory} component={PushHistory} />
    <Route path="*" component={NotFound} />
  </Switch>
);

export default AppRouter;
